import {config } from '../config';
import axios from 'axios';

export function isUserLoggedIn(){
    return localStorage.getItem('userData')!==null;
}

export function getUserId(){
    return JSON.parse(localStorage.getItem('userData'))['id'];
}

export function getUserEmail(){
    return JSON.parse(localStorage.getItem('userData'))['email'];
}
export function getUserToken(){
    return JSON.parse(localStorage.getItem('userData'))['kwtoken'];
}

export function isUserAdmin(){
    return JSON.parse(localStorage.getItem('userData'))['isAdmin'];
}

export function getUser(userid){
    let url = config.API_URL + '/User/getData.php?id=' + userid;
    //console.log("calling url:" + url);
    return fetch(url)
        .then(response => response.json())
        .then(responseJson => {
            //console.log("response:", responseJson);
            return responseJson;
        });
}


export function login(email, password){
    //console.log("Logging user in", {email, password});
    let url = config.API_URL + '/User/login.php'
    return axios({
        method: 'post',
        url: url,
        //headers: { 'content-type': 'application/json' },
        data: JSON.stringify({email: email, password: password})
    })
    .then(result => {
        //console.log("result");
        if(result && result.data){
            localStorage.setItem('userData', JSON.stringify(result.data));
            return result.data;
        }
        else return null;
    })
    .catch(error => alert(error.message));
}

export function isEmailAlreadyExist(email){
    let url = config.API_URL + '/User/isEmailAlreadyExist.php?email=' + email;
    //console.log("calling url:" + url);
    return fetch(url)
        .then(response => response.json())
        .then(responseJson => {
            //console.log("response:", responseJson);
            return responseJson;
        });
}

export function saveUserData(values){
    //("Modify userdata", values);
    let url = config.API_URL + '/User/update.php';
    return axios({
        method: 'post',
        url: url,
        //headers: { 'content-type': 'application/json' },
        data: JSON.stringify({user: values, token: getUserToken()})
    })
    .then(result => {
        return result;
    })
    .catch(error => console.error(error.message));
}